import React from 'react';
import { tagDefaultStyles, tagActionStyles, tagOutlinedStyles, tagTextStyles, getDisabledTextColor, getTextColor } from './styles';
import { IDummyProps, TSize } from './types';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { Tooltip } from '../Tooltip';
import { Button } from '../Button';
import { paddingSize } from '../../Utilities/utils/Theming';
import * as meta from '../../meta-data.json';
import { MIcon } from '../Icon';

export const overrides = (props: IDummyProps, dataProps: any, dataAria: any, theme: any, size: TSize) => {
	const tagSize = ['mini', 'compact'].includes(size) ? 'compact' : 'default';

	return {
		Root: {
			style: ({ $theme }: any) => {
				if (props.theme === 'outline' || props.theme === 'outline-indigo' || props.theme === 'outline-cyan' || props.theme === 'outline-blue-grey') {
					return {
						...tagDefaultStyles(props, tagSize),
						...tagOutlinedStyles(props, $theme),
					};
				} else return tagDefaultStyles(props, tagSize);
			},
			props: {
				...getBaseCustomProps(props),
				...dataProps,
				...dataAria,
				'data-epo': `epo-tag-${meta.version}`,
				part: `epo-tag-${meta.version}`,
				className: `tag ${props.className}`,
				role: 'button',
				tabIndex: props.onClick ? 0 : -1,
			},
		},
		Action: {
			style: ({ $variant, $theme, $isHovered, $isFocused }: any) => {
				return {
					...tagActionStyles(props, $variant, $theme, $isFocused, tagSize),
				};
			},
			props: {
				'data-testid': 'tag-close-button',
				'aria-hidden': undefined,
				role: 'button',
				tabIndex: -1
			},
		},
		ActionIcon: {
			component: () => (
				<Tooltip tab-index={-1} content={props.disabled ? '' : 'Remove'}>
					<Button
						theme="minimal"
						aria-label="Remove"
						disabled={props.disabled}
						tabIndex={0}
						onClick={(e: any) => {
							e.stopPropagation();
							props.onActionClick && props.onActionClick(e)
						}}
						overrides={{
							BaseButton: {
								style: {
									...paddingSize('0', '0', '0', '0'),
									backgroundColor: 'transparent',
									height: '18px',
									cursor: props.disabled ? 'not-allowed' : 'pointer',
									':hover': {
										backgroundColor: 'transparent',
									},
								},
							},
						}}
					>
						<MIcon
							icon="close"
							aria-hidden="true"
							style={{
								cursor: props.disabled ? 'not-allowed' : 'pointer',
								color: props.disabled
									? getDisabledTextColor(props.theme)
									: props.actionIconColor || getTextColor(props.theme),
							}}
							size="var(--epods--icon-small)"
						// }
						/>
					</Button>
				</Tooltip>
			),
		},
		Text: {
			style: ({ $theme }: any) => {
				return {
					...tagTextStyles(props, $theme, tagSize),
				};
			},
			props: {
				'data-epo': 'epo-tag-text',
				title: undefined
			}
		},
	};
};
